import { render, staticRenderFns } from "./ChipGroup.vue?vue&type=template&id=cf1ac56a&scoped=true&"
import script from "./ChipGroup.vue?vue&type=script&lang=js&"
export * from "./ChipGroup.vue?vue&type=script&lang=js&"
import style0 from "./ChipGroup.vue?vue&type=style&index=0&id=cf1ac56a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1ac56a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
